module.exports = __webpack_public_path__ + "img/azo-logo.0b19e74f.png";